const measureContext = document.createElement('canvas').getContext('2d');

export function getTextWidth(text: string, fontSize: number, unit = 'pt') {
  if (!measureContext) return 0;
  measureContext.font = `${fontSize}${unit} 'Heebo'`;
  return measureContext.measureText(text).width;
}
